import { authAPI } from '../services/api';
import { eventToRouteMap } from './constants';

/**
 * Handles Apply Now button click
 * Checks dashboard data and navigates based on next_event_name
 * If already registered, navigates to /thank-you
 * Otherwise navigates to /apply-now
 */
export const handleApplyNow = async (navigate) => {
  const profileId = localStorage.getItem('profile_id') || '';
  
  // If no profile_id, go to apply-now page
  if (!profileId) {
    navigate('/apply/pan-mobile');
    return;
  }

  try {
    // Get dashboard data to check next_event_name
    const response = await authAPI.getDashboardData(profileId);
    
    if (response.Status === 1) {
      const nextEventName = response.Data?.next_event_name;
      console.log("nextEventName", nextEventName);

      
      // If already registered, go to thank-you page
      if (nextEventName && eventToRouteMap[nextEventName]) {
        navigate(eventToRouteMap[nextEventName]);
        return;
      }
    }
    
    // Default: navigate to apply-now page
    navigate('/apply/pan-mobile');
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    // On error, navigate to apply-now page
    navigate('/apply/pan-mobile');
  }
};

